import ExcelJS from "exceljs";
import moment from "moment";

export default class CuentaCXCExcel {
  static formatearFecha(timestamp) {
    if (!timestamp) return "";
    
    const date = new Date(timestamp);
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const anio = date.getFullYear();
    const horas = String(date.getHours()).padStart(2, "0");
    const minutos = String(date.getMinutes()).padStart(2, "0");

    return `${dia}-${mes}-${anio} ${horas}:${minutos}`;
  }

  static generateWorkbook(data) {
    if (!data || !Array.isArray(data)) {
      console.error("Error: Los datos proporcionados no son un array válido", data);
      return null;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("CxC");

    worksheet.columns = [
      { key: "cliente", width: 35 },
      { key: "identificador", width: 25 },
      { key: "fecha", width: 20 },
      { key: "total", width: 15, style: { numFmt: "#,##0.00" } },
      { key: "moneda", width: 10 },
      { key: "productos", width: 15 },
    ];

    const titleRow = worksheet.addRow(["CxC"]);
    worksheet.mergeCells("A1:F1");
    
    const titleCell = titleRow.getCell(1);
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4F81BD" } 
    };

    const headers = [
      "Cliente",
      "Identificador",
      "Fecha creación",
      "Total CXC",
      "Moneda",
      "Productos"
    ];
    
    const headerRow = worksheet.addRow(headers);
    const baseBorderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    headerRow.eachCell((cell) => {
      cell.font = { bold: true, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = baseBorderStyle;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFDCE6F1" } 
      };
    });

    data.forEach((cuenta, index) => {
      const catalogoValido = Array.isArray(cuenta.Catalogo)
        ? cuenta.Catalogo
        : [];
      const totalProductos = catalogoValido.length;

      const isEven = index % 2 === 0;
      const blockFillColor = isEven ? "FFFFFFFF" : "FFF2F2F2";

      const filaPadre = worksheet.addRow({
        cliente: cuenta.NombreCompleto || "Sin Cliente",
        identificador: cuenta.id,
        fecha: CuentaCXCExcel.formatearFecha(cuenta.FechaCreacion),
        total: cuenta.total || 0,
        moneda: cuenta.moneda || "USD",
        productos: totalProductos,
      });

      filaPadre.eachCell((cell) => {
        cell.border = baseBorderStyle;
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: blockFillColor },
        };
      });

      if (totalProductos > 0) {
        catalogoValido.forEach((item) => {
          const tienePrecio = item?.Pco?.C !== undefined && item?.Pco?.C !== null;
          const tieneDivisa =
            item?.Pco?.M !== undefined &&
            item?.Pco?.M !== null &&
            String(item.Pco.M).trim() !== "";
          const tieneFechaProducto = Boolean(item?.ExtraParams?.CuentaData?.Crat);

          const precioProducto = tienePrecio ? item.Pco.C : "";
          const divisaProducto = tieneDivisa ? item.Pco.M : "";
          const nombreProducto = item.Nombre || "Sin nombre";
          const fechaProducto = tieneFechaProducto
            ? moment(item.ExtraParams.CuentaData.Crat).format(
                "DD-MM-YYYY HH:mm",
              )
            : "";

          const valorColumnaPrecio =
            tienePrecio || tieneDivisa
              ? tienePrecio
                ? precioProducto
                : divisaProducto
              : "";
          const valorColumnaDivisa = tienePrecio && tieneDivisa ? divisaProducto : "";

          const filaHija = worksheet.addRow([
            "",
            nombreProducto,
            fechaProducto,
            valorColumnaPrecio,
            "",
            valorColumnaDivisa,
          ]);

          const rowNumber = filaHija.number;
          if (!tieneFechaProducto) {
            worksheet.mergeCells(`B${rowNumber}:C${rowNumber}`);
          }

          if (tienePrecio && tieneDivisa) {
            worksheet.mergeCells(`D${rowNumber}:E${rowNumber}`);
          } else {
            worksheet.mergeCells(`D${rowNumber}:F${rowNumber}`);
          }

          filaHija.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.border = baseBorderStyle;
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: blockFillColor },
            };

            if (colNumber === 2) {
              cell.font = { bold: true, color: { argb: "FF000000" } };
            }
          });
        });
      }
    });

    return workbook;
  }

  static async generateExcelBuffer(data) {
    const workbook = CuentaCXCExcel.generateWorkbook(data);
    // console.log(workbook, "workbook generado");
    if (!workbook) return null;
    return await workbook.xlsx.writeBuffer();
  }
}
